module.exports = __webpack_public_path__ + "img/bgpic2.03a15b71.png";